/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiAlertRfiMessageType {
    SENT = 'SENT',
    RECEIVED = 'RECEIVED',
    INTERNAL = 'INTERNAL',
    SYSTEM = 'SYSTEM',
    EXTERNAL_UNENCRYPTED = 'EXTERNAL_UNENCRYPTED'
}


export function instanceOfInternalApiAlertRfiMessageType(value: any): boolean {
    for (const key in InternalApiAlertRfiMessageType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiAlertRfiMessageType, key)) {
            if (InternalApiAlertRfiMessageType[key as keyof typeof InternalApiAlertRfiMessageType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiAlertRfiMessageTypeFromJSON(json: any): InternalApiAlertRfiMessageType {
    return InternalApiAlertRfiMessageTypeFromJSONTyped(json, false);
}

export function InternalApiAlertRfiMessageTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertRfiMessageType {
    return json as InternalApiAlertRfiMessageType;
}

export function InternalApiAlertRfiMessageTypeToJSON(value?: InternalApiAlertRfiMessageType | null): any {
    return value as any;
}

export function InternalApiAlertRfiMessageTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiAlertRfiMessageType {
    return value as InternalApiAlertRfiMessageType;
}

